import { render, staticRenderFns } from "./ReviewStatusTag.vue?vue&type=template&id=7adbed23&"
import script from "./ReviewStatusTag.vue?vue&type=script&lang=js&"
export * from "./ReviewStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports